var _rect, _circle, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 110,
    viewBox: "0 0 89 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 36.8184,
    y: 37.6113,
    width: 35.2015,
    height: 35.2015,
    transform: "rotate(-15 36.8184 37.6113)",
    fill: "#E0B598"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29.3064,
    cy: 94.9773,
    r: 10.9714,
    fill: "#6DA3A3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0479,
    y: 41.4053,
    width: 35.2015,
    height: 35.2015,
    transform: "rotate(-15 34.0479 41.4053)",
    stroke: "black",
    strokeWidth: 1.92061
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.7456 16.6915L12.6801 19.8194L30.1592 85.0522M43.895 92.9826C45.4981 98.9655 41.9476 105.115 35.9646 106.718C29.9817 108.322 23.8319 104.771 22.2288 98.788C20.6257 92.8051 24.1762 86.6553 30.1592 85.0522M43.895 92.9826C42.2919 86.9996 36.1421 83.4491 30.1592 85.0522M43.895 92.9826L85.7835 81.1513",
    stroke: "black",
    strokeWidth: 1.92061
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.b2b6dd80c0162c0f633d2eb9bc7c598a.svg";
export { ForwardRef as ReactComponent };